const ExceptionMessage = ({ message }) => {
    return (
        <div className="exception-message">
            <i className="fa-solid fa-heart-crack"></i>
            {message}
        </div>
    );
};

export default ExceptionMessage;